import { render } from "./AISearchTestDialog.vue?vue&type=template&id=813dd75c&scoped=true"
import script from "./AISearchTestDialog.vue?vue&type=script&lang=js"
export * from "./AISearchTestDialog.vue?vue&type=script&lang=js"

import "./AISearchTestDialog.vue?vue&type=style&index=0&id=813dd75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813dd75c"]])

export default __exports__